import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../FlowConfigurationInputs/TextInput/NewTextInput';
import FieldLabel from '../../../FlowConfigurationInputs/FieldLabel/FieldLabel';
import Keyboard from './Keyboard/Keyboard';
import { useRecoilState } from 'recoil';
import { outNewValueAtom } from '../../../../recoil-store/recoil-state';
// import { useRecoilState } from 'recoil';
// import { isFocusAtom } from '../../../../recoil-store/recoil-state';

const orjSimpleKeyboard = [[
    { combinationKey: false, active: false, keyCode: "escape", label: "esc" }, { combinationKey: false, active: false, keyCode: "f1", label: "f1" }, { combinationKey: false, active: false, keyCode: "f2", label: "f2" }, { combinationKey: false, active: false, keyCode: "f3", label: "f3" }, { combinationKey: false, active: false, keyCode: "f4", label: "f4" }, { combinationKey: false, active: false, keyCode: "f5", label: "f5" }, { combinationKey: false, active: false, keyCode: "f6", label: "f6" },
    { combinationKey: false, active: false, keyCode: "f7", label: "f7" }, { combinationKey: false, active: false, keyCode: "f8", label: "f8" }, { combinationKey: false, active: false, keyCode: "f9", label: "f9" }, { combinationKey: false, active: false, keyCode: "f10", label: "f10" }, { combinationKey: false, active: false, keyCode: "f11", label: "f11" }, { combinationKey: false, active: false, keyCode: "f12", label: "f12" }
], [
    { combinationKey: true, active: false, keyCode: "`", label: "`" }, { combinationKey: false, active: false, keyCode: "1", label: "1" }, { combinationKey: false, active: false, keyCode: "2", label: "2" }, { combinationKey: false, active: false, keyCode: "3", label: "3" }, { combinationKey: false, active: false, keyCode: "4", label: "4" }, { combinationKey: false, active: false, keyCode: "5", label: "5" }, { combinationKey: false, active: false, keyCode: "6", label: "6" },
    { combinationKey: false, active: false, keyCode: "7", label: "7" }, { combinationKey: false, active: false, keyCode: "8", label: "8" }, { combinationKey: false, active: false, keyCode: "9", label: "9" }, { combinationKey: false, active: false, keyCode: "0", label: "0" }, { combinationKey: false, active: false, keyCode: "-", label: "-" }, { combinationKey: false, active: false, keyCode: "=", label: "=" }, { combinationKey: true, active: false, keyCode: "backspace", label: "backspace" }
], [
    { combinationKey: false, active: false, keyCode: "tab", label: "tab" }, { combinationKey: false, active: false, keyCode: "q", label: "q" }, { combinationKey: false, active: false, keyCode: "w", label: "w" }, { combinationKey: false, active: false, keyCode: "e", label: "e" }, { combinationKey: false, active: false, keyCode: "r", label: "r" }, { combinationKey: false, active: false, keyCode: "t", label: "t" }, { combinationKey: false, active: false, keyCode: "y", label: "y" },
    { combinationKey: false, active: false, keyCode: "u", label: "u" }, { combinationKey: false, active: false, keyCode: "ı", label: "ı" }, { combinationKey: false, active: false, keyCode: "o", label: "o" }, { combinationKey: false, active: false, keyCode: "p", label: "p" }, { combinationKey: false, active: false, keyCode: "[", label: "[" }, { combinationKey: false, active: false, keyCode: "]", label: "]" }, { combinationKey: false, active: false, keyCode: "ü", label: "ü" }
], [
    { combinationKey: true, active: false, keyCode: "capslock", label: "caps lock" }, { combinationKey: false, active: false, keyCode: "a", label: "a" }, { combinationKey: false, active: false, keyCode: "s", label: "s" }, { combinationKey: false, active: false, keyCode: "d", label: "d" }, { combinationKey: false, active: false, keyCode: "f", label: "f" }, { combinationKey: false, active: false, keyCode: "g", label: "g" }, { combinationKey: false, active: false, keyCode: "h", label: "h" },
    { combinationKey: false, active: false, keyCode: "j", label: "j" }, { combinationKey: false, active: false, keyCode: "k", label: "k" }, { combinationKey: false, active: false, keyCode: "l", label: "l" }, { combinationKey: false, active: false, keyCode: ";", label: ";" }, { combinationKey: false, active: false, keyCode: "'", label: "'" }, { combinationKey: false, active: false, keyCode: "enter", label: "enter" }
], [
    { combinationKey: true, active: false, keyCode: "shift", label: "Lshift" }, { combinationKey: false, active: false, keyCode: "z", label: "z" }, { combinationKey: false, active: false, keyCode: "x", label: "x" }, { combinationKey: false, active: false, keyCode: "c", label: "c" }, { combinationKey: false, active: false, keyCode: "v", label: "v" }, { combinationKey: false, active: false, keyCode: "b", label: "b" }, { combinationKey: false, active: false, keyCode: "n", label: "n" },
    { combinationKey: false, active: false, keyCode: "m", label: "m" }, { combinationKey: false, active: false, keyCode: ",", label: "," }, { combinationKey: false, active: false, keyCode: ".", label: "." }, { combinationKey: false, active: false, keyCode: "/", label: "/" }, { combinationKey: true, active: false, keyCode: "shift", label: "Rshift" }
], [
    { combinationKey: true, active: false, keyCode: "ctrl", label: "ctrl" }, { combinationKey: true, active: false, keyCode: "alt", label: "alt" }, { combinationKey: true, active: false, keyCode: "cmd", label: "cmd" }, { combinationKey: false, active: false, keyCode: "space", label: "" }, { combinationKey: true, active: false, keyCode: "alt", label: "alt gr" }, { combinationKey: true, active: false, keyCode: "ctrl", label: "ctrl" }
]]
const orjControlArrows = [
    [
        [
            { combinationKey: false, active: false, keyCode: "print", label: "print" }, { combinationKey: false, active: false, keyCode: "scroll", label: "scroll" }, { combinationKey: false, active: false, keyCode: "pause", label: "pause" }
        ], [
            { combinationKey: false, active: false, keyCode: "insert", label: "ins" }, { combinationKey: false, active: false, keyCode: "home", label: "home" }, { combinationKey: false, active: false, keyCode: "pageup", label: "up" }
        ], [
            { combinationKey: false, active: false, keyCode: "delete", label: "del" }, { combinationKey: false, active: false, keyCode: "end", label: "end" }, { combinationKey: false, active: false, keyCode: "pagedown", label: "down" }
        ]
    ],
    [
        [
            { combinationKey: true, active: false, keyCode: "arrow up", label: `\u2191` }
        ], [
            { combinationKey: true, active: false, keyCode: "arrow left", label: "\u2190" }, { combinationKey: true, active: false, keyCode: "arrow down", label: "\u2193" }, { combinationKey: true, active: false, keyCode: "arrow right", label: "\u2192" }
        ]
    ]
]
const orjNumPad = [
    [
        [
            { combinationKey: true, active: false, keyCode: "num_lock", label: "num" }, { combinationKey: false, active: false, keyCode: "/", label: "/" }, { combinationKey: false, active: false, keyCode: "*", label: "*" }
        ], [
            { combinationKey: false, active: false, keyCode: "7", label: "7" }, { combinationKey: false, active: false, keyCode: "8", label: "8" }, { combinationKey: false, active: false, keyCode: "9", label: "9" }
        ], [
            { combinationKey: false, active: false, keyCode: "4", label: "4" }, { combinationKey: false, active: false, keyCode: "5", label: "5" }, { combinationKey: false, active: false, keyCode: "6", label: "6" }
        ], [
            { combinationKey: false, active: false, keyCode: "1", label: "1" }, { combinationKey: false, active: false, keyCode: "2", label: "2" }, { combinationKey: false, active: false, keyCode: "3", label: "3" }
        ], [
            { combinationKey: false, active: false, keyCode: "0", label: "0" }, { combinationKey: false, active: false, keyCode: ",", label: "." }
        ]
    ],
    [
        [
            { combinationKey: false, active: false, keyCode: "-", label: "-" }
        ], [
            { combinationKey: false, active: false, keyCode: "+", label: "+" }
        ], [
            { combinationKey: false, active: false, keyCode: "enter", label: "enter" }
        ],
    ]]




/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Param       variableRenbder - variable render
 * @Returns     Component
 * @Author      Emirhan Bilal Yeşil
 */
function KeyPress({ action, variables, setOpenVariable }) {
    const [openOSK, setOpenOSK] = useState(false)
    const [isCombination, setIsCombination] = useState(false)
    const [simpleKeyboard, setSimleKeyboard] = useState(false)
    const [controlArrows, setControlArrows] = useState(false)
    const [numPad, setNumPad] = useState(false)
    const [newValue, setNewValue] = useState({ isOk: false, value: "" })


    const { t } = useTranslation();
    const label = 'CONTENT.CONFIGURATION-FORM.DESKTOP-RECORDER.WAIT.';
    const keyboardRef = useRef(null);

    useEffect(() => {
        setSimleKeyboard(JSON.parse(JSON.stringify(orjSimpleKeyboard)));
        setControlArrows(JSON.parse(JSON.stringify(orjControlArrows)));
        setNumPad(JSON.parse(JSON.stringify(orjNumPad)));
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [])

    const handleClickOutside = (event) => {
        if (keyboardRef.current && !keyboardRef.current.contains(event.target)) {
            setOpenOSK(false);
        }
    };

    const onClick = (button) => {
        const value = checkKeyboardKeys(button)
        setNewValue({ isOk: true, value })
    }

    const checkKeyboardKeys = (button) => {
        let value
        if (button.combinationKey) {
            if (button.active) {
                button.active = false
                if (action.fields.value.value.includes(` + ${button.keyCode}`)) {
                    value = action.fields.value.value.replace(` + ${button.keyCode}`, '');
                }
                else if (action.fields.value.value.includes(`${button.keyCode} + `)) {
                    value = action.fields.value.value.replace(`${button.keyCode} + `, '');
                }
                else {
                    value = action.fields.value.value.replace(button.keyCode, '');
                }
            }
            else {
                button.active = true
                if (action.fields.value.value !== "") {
                    value = action.fields.value.value + " + " + button.keyCode
                }
                else {
                    value = button.keyCode
                }
                setIsCombination(true)
            }
        }
        else {
            if (action.fields.value.value !== "") {
                if (isCombination) {
                    value = action.fields.value.value + " + " + button.keyCode
                }
                else {
                    value = action.fields.value.value + button.keyCode
                }
            }
            else {
                value = button.keyCode
            }
            setIsCombination(false)
        }
        checkKeyActive(value)
        return value
    }

    const checkKeyActive = useCallback((newValue) => {
        let tempSimpleKeyboard = [...simpleKeyboard]
        tempSimpleKeyboard.forEach((row) => row.forEach((button) => {
            if (newValue.includes(`${button.keyCode}`) && button.combinationKey) {
                if (button.keyCode === "f1") {
                    let test = newValue
                    test = test.replace("f11", '');
                    test = test.replace("f10", '');
                    test = test.replace("f12", '');
                    button.active = test.includes("f1")
                    return
                }
                button.active = true
            }
            else {
                button.active = false
            }
        }))


        let tempControlArrow = [...controlArrows]
        tempControlArrow.forEach((area) => area.forEach((row) => {
            row.forEach((button) => {
                if (newValue.includes(`${button.keyCode}`) && button.combinationKey) {
                    button.active = true
                }
                else {
                    button.active = false
                }
            })

        }))

        let tempNumPad = [...numPad]
        tempNumPad.forEach((area) => area.forEach((row) => {
            row.forEach((button) => {
                if (newValue.includes(`${button.keyCode}`) && button.combinationKey) {
                    button.active = true
                }
                else {
                    button.active = false
                }
            })
        }))

        setSimleKeyboard(tempSimpleKeyboard);
        setControlArrows(tempControlArrow);
        setNumPad(tempNumPad);
        //setRefresh(!refresh)
    }, [simpleKeyboard, controlArrows, numPad])


    return (
        <>
            <div className="conf-field-container" >
                <FieldLabel name={t(label + 'VALUE')} />
                <TextInput action={action} inputName="value" variables={variables} outNewValue={newValue}
                    setOpenVariable={setOpenVariable} filter="string" onfocus={() => setOpenOSK(true)} outOnChange={checkKeyActive} />

            </div>
            {action.fields.image?.byteValue && <img src={`data:image/jpeg;base64,${action.fields.image.byteValue}`} alt="autommate_keypress" />}
            {openOSK && <Keyboard onClick={onClick} simpleKeyboard={simpleKeyboard} controlArrows={controlArrows} numPad={numPad} keyboardRef={keyboardRef} errorReaction={action.fields?.errorReaction?.value} />}
        </>
    );
}
export default KeyPress;